import { Network } from '@kattana-io/common';
import { toFixed4 } from '../../../DexTrades/formatters';
import { formatWallet } from '../formatters';
import Text from '../../../../atoms/Text';
import {
  formatMobileTableData,
  IMobileTableScema,
} from '../../../../helpers/formatters';
import BodyTableMobile from '../../ModalTable/mobile/BodyTable';
import { ITopTradersTrade, ITradesTableProps } from '../TradesTable';

const getClassNameForRow = (rowData: ITopTradersTrade | undefined) => {
  if (rowData) {
    if (rowData.buy) {
      return 'text--green-600';
    }
    return 'text--red-600';
  }

  return 'text--grey-400';
};

const TradesTableMobile = (props: ITradesTableProps) => {
  const onTxClick = (tx: string) => {
    const txUrl = Network.fromChain(props.chain)?.getScan() || '';
    window.open(`${txUrl}${tx}`);
  };

  const { base, quote, trades, base_decimals, quote_decimals, flipped } = props;

  const schema: IMobileTableScema = {
    row_1: {
      item_1: {
        name: 'Date',
        accessor: 'format_date',
        width: 150,
      },
      item_2: {
        name: 'Price USD',
        accessor: 'price_a_usd',
        parser: (value, row) => (
          <Text size={14} className={getClassNameForRow(row)}>
            ${toFixed4(value)}
          </Text>
        ),
      },
    },
    row_2: {
      item_1: {
        name: `(${quote})`,
        accessor: 'price_a',
        parser: (value) => `(${toFixed4(value)})`,
        width: 150,
      },
      item_2: {
        name: `Amount ${base}`,
        accessor: flipped ? 'amount1' : 'amount0',
        parser: (value) => `${toFixed4(Number(value) / 10 ** base_decimals)}`,
      },
    },
    row_3: {
      item_1: {
        name: `Total ${quote}`,
        accessor: flipped ? 'amount0' : 'amount1',
        parser: (value) => `${toFixed4(Number(value) / 10 ** quote_decimals)}`,
        width: 150,
      },
      item_2: {
        name: 'Txn Value (USD)',
        accessor: 'value_usd',
        parser: (value) => `$${toFixed4(Number(value))}`,
      },
    },
    row_4: {
      item_1: {
        name: 'Txn Hash',
        accessor: 'tx',
        parser: (value) => `${formatWallet(value)}`,
        onClick: (row) => onTxClick(row.tx),
        color: 'navy',
      },
    },
  };

  const parsedData = formatMobileTableData({
    data: trades,
    schema,
    getColorForItem: () => 'grey',
  });

  return <BodyTableMobile data={parsedData} />;
};

export default TradesTableMobile;
